// Default values based on home carousel requirements
export default {
  AUTOPLAY: true,
  CONTROLLER_OVERLAY: true,
  CONTROLLER_POSITION: 'bottom',
  CONTROLLER_VARIANT: 'dots',
  DISPLAY_NAVIGATION: true,
  INTERVAL: 5000,
}
